const cor1 = "#6632FE"
const cor2 = "#E34232"

export const textosCards = [
    {
        id: 1,
        titulo: "Diária Express",
        cor: cor1,
        descricao: `O Diária Express é um sistema proposto para centralizar e organizar o gerenciamento de trabalhadores 
            eventuais (“folguistas”) em uma empresa de serviços, substituindo o controle manual feito por planilhas e mensagens. 
            A ideia é criar um aplicativo mobile para que supervisores registrem e acompanhem as diárias — informando dados como 
            data, cliente, trabalhador, motivo e valor — além de permitir contato direto com os folguistas e visualizar históricos 
            de lançamentos. Complementarmente, uma aplicação web permitiria ao administrador consolidar os registros, exportar 
            dados para pagamento em lote e evitar erros comuns como pagamentos duplicados ou informações inconsistentes, tornando 
            o processo de gestão e pagamento das diárias mais eficiente e confiável.`
    },
    {
        id: 2,
        titulo: "Actae",
        cor: cor1,
        descricao: `O Actae é um aplicativo projetado para registrar acontecimentos de forma cronológica, precisa e organizada, 
            transformando anotações feitas no momento dos fatos em relatórios formais. A ferramenta permite que o usuário registre 
            eventos diretamente pelo celular — adicionando descrições, datas, horários, fotos e outras evidências — criando 
            automaticamente uma linha do tempo estruturada. Ao final, o sistema pode gerar um documento profissional em formato 
            de relatório ou ata, útil para fins técnicos, administrativos ou jurídicos, garantindo fidelidade dos acontecimentos 
            e evitando a perda de informações que normalmente ocorreria ao tentar reconstruir os fatos posteriormente.`
    },
    {
        id: 3,
        titulo: "Tablinum",
        cor: cor2,
        descricao: `O Tablinum é um aplicativo completo para a administração de condomínios, desenvolvido para tornar a gestão 
        mais simples, eficiente e transparente. Com uma interface intuitiva, a plataforma centraliza o controle financeiro, 
        a comunicação entre síndicos e moradores, a gestão de documentos e o acompanhamento de ocorrências em um só lugar. 
        O Tablinum permite automatizar tarefas, reduzir a burocracia e melhorar a organização do condomínio, proporcionando 
        mais praticidade no dia a dia e uma experiência mais moderna para todos os usuários.`
    }
]

export const frasesD = [
    "AUDENTES FORTUNA IUVAT",
    "NÃO IMPORTA SE O PATO É MACHO OU FÊMEA,EU SÓ QUERO O OVO",
    "A MULHER DE CÉSAR NÃO BASTA SER HONESTA, DEVE PARECER HONESTA",
    "DURA DISCIPLINA, FACILIS BELUM",
    "ARS LONGA, VITA BREVIS",
    "VERBA DOCENT, EXEMPLA TRAHUNT"
]